'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _FadeSlideTransition = require('conversations-visitor-experience-components/transition/FadeSlideTransition');

var _FadeSlideTransition2 = _interopRequireDefault(_FadeSlideTransition);

var _WidgetLocations = require('conversations-visitor-experience-components/visitor-widget/constants/WidgetLocations');

var _CurrentViewContainer = require('../current-view/CurrentViewContainer');

var _CurrentViewContainer2 = _interopRequireDefault(_CurrentViewContainer);

var _LauncherContainer = require('../launcher/container/LauncherContainer');

var _LauncherContainer2 = _interopRequireDefault(_LauncherContainer);

var _InitialMessageBubbleContainer = require('../initial-message-bubble/containers/InitialMessageBubbleContainer');

var _InitialMessageBubbleContainer2 = _interopRequireDefault(_InitialMessageBubbleContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ApplicationLayout = function (_React$Component) {
  _inherits(ApplicationLayout, _React$Component);

  function ApplicationLayout(props) {
    _classCallCheck(this, ApplicationLayout);

    var _this = _possibleConstructorReturn(this, (ApplicationLayout.__proto__ || Object.getPrototypeOf(ApplicationLayout)).call(this, props));

    _this.getIframeDimensions = _this.getIframeDimensions.bind(_this);
    _this.onIframeResize = _this.onIframeResize.bind(_this);
    _this.onOpenUpdate = _this.onOpenUpdate.bind(_this);
    _this.setLauncherRef = _this.setLauncherRef.bind(_this);
    _this.setInitialMessageRef = _this.setInitialMessageRef.bind(_this);
    _this.setWidgetRef = _this.setWidgetRef.bind(_this);
    _this.openWidget = _this.openWidget.bind(_this);
    _this.closeWidget = _this.closeWidget.bind(_this);

    _this.getLauncherBoundingRect = _this.getLauncherBoundingRect.bind(_this);
    _this.getInitialMessageBoundingRect = _this.getInitialMessageBoundingRect.bind(_this);
    _this.getWidgetBoundingRect = _this.getWidgetBoundingRect.bind(_this);
    return _this;
  }

  _createClass(ApplicationLayout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.onIframeResize();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(nextProps) {
      if (nextProps.browserWindowHeight !== this.props.browserWindowHeight || nextProps.browserWindowWidth !== this.props.browserWindowWidth) {
        this.onIframeResize();
      }
    }
  }, {
    key: 'onIframeResize',
    value: function onIframeResize() {
      this.props.onIframeResize(this.getIframeDimensions());
    }
  }, {
    key: 'getLauncherBoundingRect',
    value: function getLauncherBoundingRect() {
      return this.launcherRef ? this.launcherRef.getBoundingClientRect() : { width: 0, height: 0 };
    }
  }, {
    key: 'getInitialMessageBoundingRect',
    value: function getInitialMessageBoundingRect() {
      return this.initialMessageRef ? this.initialMessageRef.getBoundingClientRect() : { width: 0, height: 0 };
    }
  }, {
    key: 'getWidgetBoundingRect',
    value: function getWidgetBoundingRect() {
      return this.widgetRef ? this.widgetRef.getBoundingClientRect() : { width: 0, height: 0 };
    }
  }, {
    key: 'getIframeDimensions',
    value: function getIframeDimensions() {
      var MARGIN_PX = 16;
      var _props = this.props,
          isOpen = _props.isOpen,
          mobile = _props.mobile;

      var activeContent = void 0;

      // open widget on mobile takes up the entire screen
      if (isOpen && mobile) {
        return {
          height: this.props.browserWindowHeight,
          width: this.props.browserWindowWidth
        };
      }

      if (isOpen) {
        activeContent = this.getWidgetBoundingRect();
      } else {
        activeContent = this.getInitialMessageBoundingRect();
      }
      var launcher = this.getLauncherBoundingRect();
      return {
        width: (activeContent.width || launcher.width) + MARGIN_PX,
        height: launcher.height + activeContent.height + MARGIN_PX
      };
    }
  }, {
    key: 'onOpenUpdate',
    value: function onOpenUpdate(isOpened) {
      this.props.toggleOpen(isOpened);
    }
  }, {
    key: 'setLauncherRef',
    value: function setLauncherRef(element) {
      this.launcherRef = (0, _reactDom.findDOMNode)(element);
      this.onIframeResize();
    }
  }, {
    key: 'setInitialMessageRef',
    value: function setInitialMessageRef(element) {
      this.initialMessageRef = (0, _reactDom.findDOMNode)(element);
      this.onIframeResize();
    }
  }, {
    key: 'setWidgetRef',
    value: function setWidgetRef(element) {
      this.widgetRef = (0, _reactDom.findDOMNode)(element);
      this.onIframeResize();
    }
  }, {
    key: 'openWidget',
    value: function openWidget() {
      this.props.toggleOpen(true);
      this.props.trackUserInteraction();
    }
  }, {
    key: 'closeWidget',
    value: function closeWidget() {
      this.props.toggleOpen(false);
      this.props.trackUserInteraction();
    }
  }, {
    key: 'render',
    value: function render() {
      var _launcherAlignmentCla;

      var _props2 = this.props,
          isOpen = _props2.isOpen,
          inline = _props2.inline,
          mobile = _props2.mobile,
          onLauncherHover = _props2.onLauncherHover,
          browserWindowHeight = _props2.browserWindowHeight,
          widgetLocation = _props2.widgetLocation;

      var launcherHidden = isOpen && mobile || inline;

      var launcherAlignmentClasses = (_launcherAlignmentCla = {}, _defineProperty(_launcherAlignmentCla, _WidgetLocations.LEFT_ALIGNED, 'p-right-8 pull-left'), _defineProperty(_launcherAlignmentCla, _WidgetLocations.RIGHT_ALIGNED, 'p-left-8 pull-right'), _launcherAlignmentCla);

      var launcherWrapperClasses = (0, _classNames2.default)('p-top-4', 'display-flex', launcherAlignmentClasses[widgetLocation]);
      return _react2.default.createElement(
        _FadeSlideTransition2.default,
        { leave: false, direction: 'bottom' },
        _react2.default.createElement(_CurrentViewContainer2.default, {
          browserWindowHeight: browserWindowHeight,
          inline: inline,
          isOpen: isOpen,
          onIframeResize: this.onIframeResize,
          onUpdateOpened: this.onOpenUpdate,
          onUpdateSize: this.onIframeResize,
          setWidgetRef: this.setWidgetRef
        }),
        _react2.default.createElement(_InitialMessageBubbleContainer2.default, {
          onOpen: this.openWidget,
          onUpdateSize: this.onIframeResize,
          setInitialMessageRef: this.setInitialMessageRef,
          onUpdateOpened: this.onOpenUpdate,
          widgetLocation: widgetLocation
        }),
        !launcherHidden && _react2.default.createElement(
          'span',
          {
            className: launcherWrapperClasses,
            ref: this.setLauncherRef,
            onMouseOver: onLauncherHover
          },
          _react2.default.createElement(_LauncherContainer2.default, {
            onClose: this.closeWidget,
            onOpen: this.openWidget
          })
        )
      );
    }
  }]);

  return ApplicationLayout;
}(_react2.default.Component);

ApplicationLayout.displayName = 'ApplicationLayout';

ApplicationLayout.propTypes = {
  browserWindowHeight: _react.PropTypes.number.isRequired,
  browserWindowWidth: _react.PropTypes.number,
  inline: _react.PropTypes.bool.isRequired,
  isOpen: _react.PropTypes.bool.isRequired,
  mobile: _react.PropTypes.bool.isRequired,
  onIframeResize: _react.PropTypes.func.isRequired,
  onLauncherHover: _react.PropTypes.func.isRequired,
  toggleOpen: _react.PropTypes.func.isRequired,
  trackUserInteraction: _react.PropTypes.func.isRequired,
  widgetLocation: _WidgetLocations.WidgetLocationProp
};

exports.default = ApplicationLayout;
module.exports = exports['default'];